"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosedHoursInfo = exports.ALLERGENS = exports.MENU_ITEM_COLLECTIONS = exports.MENU_TYPES = exports.COUPON_ORDER_TYPES = exports.COUPON_CHANNELS = exports.COUPON_TYPES = exports.COUPON_RESET_PERIOD = void 0;
exports.COUPON_RESET_PERIOD = [
    'immediate',
    'day',
    'week',
    'month',
    'year',
];
exports.COUPON_TYPES = [
    'ticket-percent',
    'ticket-fixed',
    'item-percent',
    'item-fixed',
];
exports.COUPON_CHANNELS = ['online', 'in-app'];
exports.COUPON_ORDER_TYPES = ['pickup', 'delivery'];
exports.MENU_TYPES = ['olo', 'catering'];
exports.MENU_ITEM_COLLECTIONS = [
    'Category',
    'Coupon',
    'Item',
    'Menu',
    'Modifier',
    'ModifierSet',
];
exports.ALLERGENS = [
    'dairy',
    'eggs',
    'fish',
    'gluten',
    'mango',
    'peanuts',
    'sesame',
    'shellfish',
    'soy',
    'tree-nuts',
];
const getClosedDailyHours = () => ({
    hours: [],
    open: false,
});
const getClosedHoursInfo = () => ({
    sunday: getClosedDailyHours(),
    monday: getClosedDailyHours(),
    tuesday: getClosedDailyHours(),
    wednesday: getClosedDailyHours(),
    thursday: getClosedDailyHours(),
    friday: getClosedDailyHours(),
    saturday: getClosedDailyHours(),
});
exports.getClosedHoursInfo = getClosedHoursInfo;
//# sourceMappingURL=constants.js.map